import { useQuery } from '@tanstack/react-query';
import fetchAPI from '../fetchAPI';

export type AiModelHistoryField = 'inputPrice' | 'outputPrice' | 'groupName' | 'sortOrder' | 'isActive' | 'deleted';

export interface AiModelHistoryRow {
  id: string;
  aiModelId: string;
  model: string;
  field: AiModelHistoryField;
  // NULL marks the migration-137 seed / creation anchor.
  oldValue: string | null;
  newValue: string;
  changedAt: string;
  changedBy: string | null;
  changedByUserName: string | null;
}

interface Props {
  id?: string;
  // Gate the fetch until the modal actually opens.
  enabled?: boolean;
}

export const useAiModelHistory = ({ id, enabled = true }: Props) =>
  useQuery({
    queryKey: ['ai-models/history', id],
    queryFn: async (): Promise<AiModelHistoryRow[]> => {
      const response = await fetchAPI<{ data: AiModelHistoryRow[] }>({
        method: 'GET',
        route: `ai-models/${id}/history`
      });
      return response?.data?.data ?? [];
    },
    enabled: Boolean(id) && enabled,
    // Reopen-for-fresh, like useMarkupHistory: opened right after a price edit.
    staleTime: 0,
    refetchOnMount: 'always'
  });

export default useAiModelHistory;
